import React from 'react';

import Icon from '@material-ui/core/Icon';

import Grid from '@material-ui/core/Grid';

import StyledButton from './models/Button.jsx';

import { appUrl, pingClientID, pingClientSecret, pingOAuthUrl } from '../../utils/config.js';

export default function SignInping(props) {

  const inviteToken =

    new URLSearchParams(window.location.search).get('token') || '12345';

//export default function SignInping() {

  return (

    <Grid container justify="center">

      <Grid

        item

        xs={12}

        sm={10}

        md={6}

        style={{ textAlign: 'center', marginTop: '2rem' }}

      >

        <StyledButton

          variant="contained"

          color="secondary"

          size="medium"

          id="login_ping"

          startIcon={

            <Icon style={{ paddingRight: '2rem' }}>

              <i className="fas fa-user-lock" style={{ fontSize: '1.5rem' }}></i>

            </Icon>

          }

          style={{

            paddingLeft: '3rem',

            paddingRight: '3rem',

          }}

        >

          <a
            href={`${pingOAuthUrl}?client_id=${pingClientID}&redirect_uri=${appUrl}/pingAMLogin&response_type=code&scope=openid%20profile%20email&state=${inviteToken}`}
            target="_self"
            style={{ color: '#FFFFFF', textDecoration: 'none' }}
          >

            {!props.sessionTimeout ?  "Sign In using Ping" : "Sign back in using Ping"}

          </a>

        </StyledButton>

      </Grid>

    </Grid>

  );

}